import {
  categoryTranslationFragment,
  collectionTranslationFragment,
  comboTranslationFragment,
  cornerMarkTranslationFragment,
  extrachargeTranslationFragment,
  hotSearchTranslationFragment,
  loginPopupTranslationFragment,
  menuBannerTranslatableFragment,
  menuItemTranslatableFragment,
  pageHeaderTranslatableFragment,
  pageTranslatableFragment,
  productActivationSettingTranslationFragment,
  productLensTypeTranslationFragment,
  productTagsTranslatableFragment,
  productTranslationFragment,
  productVariantTranslationFragment,
  saleTranslationFragment,
  shippingMethodTranslationFragment,
  shopTranslationFragment,
  voucherTranslationFragment
} from "@saleor/fragments/translations";
import gql from "graphql-tag";

import { TypedMutation } from "../mutations";
import {
  UpdateAttributeTranslations,
  UpdateAttributeTranslationsVariables
} from "./types/UpdateAttributeTranslations";
import {
  UpdateAttributeValueTranslations,
  UpdateAttributeValueTranslationsVariables
} from "./types/UpdateAttributeValueTranslations";
import {
  UpdateCategoryTranslations,
  UpdateCategoryTranslationsVariables
} from "./types/UpdateCategoryTranslations";
import {
  UpdateCollectionTranslations,
  UpdateCollectionTranslationsVariables
} from "./types/UpdateCollectionTranslations";
import {
  UpdateComboTranslations,
  UpdateComboTranslationsVariables
} from "./types/UpdateComboTranslations";
import {
  UpdateCornerMarkTranslations,
  UpdateCornerMarkTranslationsVariables
} from "./types/UpdateCornerMarkTranslations";
import {
  UpdateExtraChargeTranslations,
  UpdateExtraChargeTranslationsVariables
} from "./types/UpdateExtraChargeTranslations";
import {
  UpdateHotWordTranslations,
  UpdateHotWordTranslationsVariables
} from "./types/UpdateHotWordTranslations";
import {
  UpdateLoginPopupTranslations,
  UpdateLoginPopupTranslationsVariables
} from "./types/UpdateLoginPopupTranslations";
import {
  UpdateMenuBannerTranslations,
  UpdateMenuBannerTranslationsVariables
} from "./types/UpdateMenuBannerTranslations";
import {
  UpdateMenuItemTranslations,
  UpdateMenuItemTranslationsVariables
} from "./types/UpdateMenuItemTranslations";
import {
  UpdatePageHeaderTranslations,
  UpdatePageHeaderTranslationsVariables
} from "./types/UpdatePageHeaderTranslations";
import {
  UpdatePageTranslations,
  UpdatePageTranslationsVariables
} from "./types/UpdatePageTranslations";
import {
  UpdateProductActivationSettingTranslations,
  UpdateProductActivationSettingTranslationsVariables
} from "./types/UpdateProductActivationSettingTranslations";
import {
  UpdateProductLensTypeTranslations,
  UpdateProductLensTypeTranslationsVariables
} from "./types/UpdateProductLensTypeTranslations";
import {
  UpdateProductTagTranslations,
  UpdateProductTagTranslationsVariables
} from "./types/UpdateProductTagTranslations";
import {
  UpdateProductTranslations,
  UpdateProductTranslationsVariables
} from "./types/UpdateProductTranslations";
import {
  UpdateProductTypeTranslations,
  UpdateProductTypeTranslationsVariables
} from "./types/UpdateProductTypeTranslations";
import {
  UpdateProductVariantTranslations,
  UpdateProductVariantTranslationsVariables
} from "./types/UpdateProductVariantTranslations";
import {
  UpdateSaleTranslations,
  UpdateSaleTranslationsVariables
} from "./types/UpdateSaleTranslations";
import {
  UpdateShippingMethodTranslations,
  UpdateShippingMethodTranslationsVariables
} from "./types/UpdateShippingMethodTranslations";
import {
  UpdateShopTranslations,
  UpdateShopTranslationsVariables
} from "./types/UpdateShopTranslations";
import {
  UpdateVoucherTranslations,
  UpdateVoucherTranslationsVariables
} from "./types/UpdateVoucherTranslations";

const updateProductTranslations = gql`
  ${productTranslationFragment}
  mutation UpdateProductTranslations(
    $id: ID!
    $input: ProductTranslationInput!
    $language: LanguageCodeEnum!
  ) {
    productTranslate(id: $id, input: $input, languageCode: $language) {
      errors {
        field
        message
      }
      product {
        ...ProductTranslationFragment
      }
    }
  }
`;
export const TypedUpdateProductTranslations = TypedMutation<
  UpdateProductTranslations,
  UpdateProductTranslationsVariables
>(updateProductTranslations);

const updateProductVariantTranslations = gql`
  ${productVariantTranslationFragment}
  mutation UpdateProductVariantTranslations(
    $id: ID!
    $input: ProductVariantTranslationInput!
    $language: LanguageCodeEnum!
  ) {
    productVariantTranslate(id: $id, input: $input, languageCode: $language) {
      errors {
        field
        message
      }
      productVariant {
        ...ProductVariantTranslationFragment
      }
    }
  }
`;
export const TypedUpdateProductVariantTranslations = TypedMutation<
  UpdateProductVariantTranslations,
  UpdateProductVariantTranslationsVariables
>(updateProductVariantTranslations);
const updateCategoryTranslations = gql`
  ${categoryTranslationFragment}
  mutation UpdateCategoryTranslations(
    $id: ID!
    $input: TranslationInput!
    $language: LanguageCodeEnum!
  ) {
    categoryTranslate(id: $id, input: $input, languageCode: $language) {
      errors {
        field
        message
      }
      category {
        ...CategoryTranslationFragment
      }
    }
  }
`;
export const TypedUpdateCategoryTranslations = TypedMutation<
  UpdateCategoryTranslations,
  UpdateCategoryTranslationsVariables
>(updateCategoryTranslations);

const updateCollectionTranslations = gql`
  ${collectionTranslationFragment}
  mutation UpdateCollectionTranslations(
    $id: ID!
    $input: CollectionTranslationInput!
    $language: LanguageCodeEnum!
  ) {
    collectionTranslate(id: $id, input: $input, languageCode: $language) {
      errors {
        field
        message
      }
      collection {
        ...CollectionTranslationFragment
      }
    }
  }
`;
export const TypedUpdateCollectionTranslations = TypedMutation<
  UpdateCollectionTranslations,
  UpdateCollectionTranslationsVariables
>(updateCollectionTranslations);

const updatePageTranslations = gql`
  ${pageTranslatableFragment}
  mutation UpdatePageTranslations(
    $id: ID!
    $input: PageTranslationInput!
    $language: LanguageCodeEnum!
  ) {
    pageTranslate(id: $id, input: $input, languageCode: $language) {
      errors {
        field
        message
      }
      page {
        ...PageTranslatableFragment
      }
    }
  }
`;
export const TypedUpdatePageTranslations = TypedMutation<
  UpdatePageTranslations,
  UpdatePageTranslationsVariables
>(updatePageTranslations);
const updateMenuBannerTranslations = gql`
  ${menuBannerTranslatableFragment}
  mutation UpdateMenuBannerTranslations(
    $id: ID!
    $input: MenuBannerTranslationInput!
    $language: LanguageCodeEnum!
  ) {
    menuBannerTranslate(id: $id, input: $input, languageCode: $language) {
      errors {
        field
        message
      }
      menuBanner {
        ...MenuBannerTranslatableFragment
      }
    }
  }
`;
export const TypedUpdateMenuBannerTranslations = TypedMutation<
  UpdateMenuBannerTranslations,
  UpdateMenuBannerTranslationsVariables
>(updateMenuBannerTranslations);

const updatePageHeaderTranslations = gql`
  ${pageHeaderTranslatableFragment}
  mutation UpdatePageHeaderTranslations(
    $id: ID!
    $input: PageHeaderTranslationInput!
    $language: LanguageCodeEnum!
  ) {
    pageHeaderTranslate(id: $id, input: $input, languageCode: $language) {
      errors {
        field
        message
      }
      pageHeader {
        ...PageHeaderTranslatableFragment
      }
    }
  }
`;
export const TypedUpdatePageHeaderTranslations = TypedMutation<
  UpdatePageHeaderTranslations,
  UpdatePageHeaderTranslationsVariables
>(updatePageHeaderTranslations);

const updateProductTagTranslations = gql`
  ${productTagsTranslatableFragment}
  mutation UpdateProductTagTranslations(
    $id: ID!
    $input: NameTranslationInput!
    $language: LanguageCodeEnum!
  ) {
    producttagsTranslate(id: $id, input: $input, languageCode: $language) {
      errors {
        field
        message
      }
      productTags {
        ...ProductTagsTranslationFragment
      }
    }
  }
`;
export const TypedUpdateProductTagTranslations = TypedMutation<
  UpdateProductTagTranslations,
  UpdateProductTagTranslationsVariables
>(updateProductTagTranslations);

const updateHotWordTranslations = gql`
  ${hotSearchTranslationFragment}
  mutation UpdateHotWordTranslations(
    $id: ID!
    $input: HotSearchTranslationInput!
    $language: LanguageCodeEnum!
  ) {
    hotsearchTranslate(id: $id, input: $input, languageCode: $language) {
      errors {
        field
        message
      }
      hotSearch {
        ...HotSearchTranslationFragment
      }
    }
  }
`;
export const TypedUpdateHotWordTranslations = TypedMutation<
  UpdateHotWordTranslations,
  UpdateHotWordTranslationsVariables
>(updateHotWordTranslations);

const updateVoucherTranslations = gql`
  ${voucherTranslationFragment}
  mutation UpdateVoucherTranslations(
    $id: ID!
    $input: VoucherTranslationInput!
    $language: LanguageCodeEnum!
  ) {
    voucherTranslate(id: $id, input: $input, languageCode: $language) {
      errors {
        field
        message
      }
      voucher {
        ...VoucherTranslationFragment
      }
    }
  }
`;
export const TypedUpdateVoucherTranslations = TypedMutation<
  UpdateVoucherTranslations,
  UpdateVoucherTranslationsVariables
>(updateVoucherTranslations);

const updateSaleTranslations = gql`
  ${saleTranslationFragment}
  mutation UpdateSaleTranslations(
    $id: ID!
    $input: SaleTranslationInput!
    $language: LanguageCodeEnum!
  ) {
    saleTranslate(id: $id, input: $input, languageCode: $language) {
      errors {
        field
        message
      }
      sale {
        ...SaleTranslationFragment
      }
    }
  }
`;
export const TypedUpdateSaleTranslations = TypedMutation<
  UpdateSaleTranslations,
  UpdateSaleTranslationsVariables
>(updateSaleTranslations);

const updateProductTypeTranslations = gql`
  mutation UpdateProductTypeTranslations(
    $id: ID!
    $input: NameTranslationInput!
    $language: LanguageCodeEnum!
  ) {
    productTypeTranslate(id: $id, input: $input, languageCode: $language) {
      errors {
        field
        message
      }
      productType {
        id
        name
        translation(languageCode: $language) {
          id
          name
        }
      }
    }
  }
`;
export const TypedUpdateProductTypeTranslations = TypedMutation<
  UpdateProductTypeTranslations,
  UpdateProductTypeTranslationsVariables
>(updateProductTypeTranslations);

const updateAttributeTranslations = gql`
  mutation UpdateAttributeTranslations(
    $id: ID!
    $input: AttributeTranslationInput!
    $language: LanguageCodeEnum!
  ) {
    attributeTranslate(id: $id, input: $input, languageCode: $language) {
      errors {
        field
        message
      }
      attribute {
        id
        showName
        translation(languageCode: $language) {
          id
          showName
        }
      }
    }
  }
`;
export const TypedUpdateAttributeTranslations = TypedMutation<
  UpdateAttributeTranslations,
  UpdateAttributeTranslationsVariables
>(updateAttributeTranslations);

const updateAttributeValueTranslations = gql`
  mutation UpdateAttributeValueTranslations(
    $id: ID!
    $input: NameTranslationInput!
    $language: LanguageCodeEnum!
  ) {
    attributeValueTranslate(id: $id, input: $input, languageCode: $language) {
      errors {
        field
        message
      }
      attributeValue {
        id
        name
        translation(languageCode: $language) {
          id
          name
        }
      }
    }
  }
`;
export const TypedUpdateAttributeValueTranslations = TypedMutation<
  UpdateAttributeValueTranslations,
  UpdateAttributeValueTranslationsVariables
>(updateAttributeValueTranslations);

const updateShopTranslations = gql`
  ${shopTranslationFragment}
  mutation UpdateShopTranslations(
    $input: ShopSettingsTranslationInput!
    $language: LanguageCodeEnum!
  ) {
    shopSettingsTranslate(input: $input, languageCode: $language) {
      errors {
        field
        message
      }
      shop {
        ...ShopTranslationFragment
      }
    }
  }
`;
export const TypedUpdateShopTranslations = TypedMutation<
  UpdateShopTranslations,
  UpdateShopTranslationsVariables
>(updateShopTranslations);

const updateExtraChargeTranslations = gql`
  ${extrachargeTranslationFragment}
  mutation UpdateExtraChargeTranslations(
    $id: ID!
    $input: ExtraChargeTranslationInput!
    $language: LanguageCodeEnum!
  ) {
    extraChargeTranslate(input: $input, languageCode: $language, id: $id) {
      errors {
        field
        message
      }
      extraCharge {
        ...ExtraChargeTranslationFragment
      }
    }
  }
`;

export const TypedUpdateExtraChargeTranslations = TypedMutation<
  UpdateExtraChargeTranslations,
  UpdateExtraChargeTranslationsVariables
>(updateExtraChargeTranslations);

const updateMenuItemTranslations = gql`
  ${menuItemTranslatableFragment}
  mutation UpdateMenuItemTranslations(
    $id: ID!
    $input: MenuItemTranslationInput!
    $language: LanguageCodeEnum!
  ) {
    menuItemTranslate(id: $id, input: $input, languageCode: $language) {
      errors {
        field
        message
      }
      menuItem {
        ...MenuItemTranslatableFragment
      }
    }
  }
`;
export const TypedUpdateMenuItemTranslations = TypedMutation<
  UpdateMenuItemTranslations,
  UpdateMenuItemTranslationsVariables
>(updateMenuItemTranslations);

const updateCornerMarkTranslations = gql`
  ${cornerMarkTranslationFragment}
  mutation UpdateCornerMarkTranslations(
    $id: ID!
    $input: CornerMarkTranslationInput!
    $language: LanguageCodeEnum!
  ) {
    cornerMarkTranslate(id: $id, input: $input, languageCode: $language) {
      errors {
        field
        message
      }
      cornerMark {
        ...CornerMarkTranslationFragment
      }
    }
  }
`;
export const TypedUpdateCornerMarkTranslations = TypedMutation<
  UpdateCornerMarkTranslations,
  UpdateCornerMarkTranslationsVariables
>(updateCornerMarkTranslations);

const updateShippingMethodTranslations = gql`
  ${shippingMethodTranslationFragment}
  mutation UpdateShippingMethodTranslations(
    $id: ID!
    $input: ShippingMethodTranslationInput!
    $language: LanguageCodeEnum!
  ) {
    shippingMethodTranslate(id: $id, input: $input, languageCode: $language) {
      errors {
        field
        message
      }
      shippingMethod {
        ...ShippingMethodTranslationFragment
      }
    }
  }
`;
export const TypedUpdateShippingMethodTranslations = TypedMutation<
  UpdateShippingMethodTranslations,
  UpdateShippingMethodTranslationsVariables
>(updateShippingMethodTranslations);

const updateComboTranslations = gql`
  ${comboTranslationFragment}
  mutation UpdateComboTranslations(
    $id: ID!
    $input: ComboTranslationInput!
    $language: LanguageCodeEnum!
  ) {
    comboTranslate(id: $id, input: $input, languageCode: $language) {
      errors {
        field
        message
      }
      combo {
        ...ComboTranslationFragment
      }
    }
  }
`;
export const TypedUpdateComboTranslations = TypedMutation<
  UpdateComboTranslations,
  UpdateComboTranslationsVariables
>(updateComboTranslations);

const updateLoginPopupTranslations = gql`
  ${loginPopupTranslationFragment}
  mutation UpdateLoginPopupTranslations(
    $id: ID!
    $input: LoginPopupTranslationInput!
    $language: LanguageCodeEnum!
  ) {
    loginpopupTranslate(id: $id, input: $input, languageCode: $language) {
      errors {
        field
        message
      }
      loginPopup {
        ...LoginPopupTranslationFragment
      }
    }
  }
`;
export const TypedUpdateLoginPopupTranslations = TypedMutation<
  UpdateLoginPopupTranslations,
  UpdateLoginPopupTranslationsVariables
>(updateLoginPopupTranslations);

const updateProductActivationSettingTranslations = gql`
  ${productActivationSettingTranslationFragment}
  mutation UpdateProductActivationSettingTranslations(
    $id: ID!
    $input: ProductActivationSettingTranslationInput!
    $language: LanguageCodeEnum!
  ) {
    productActivationSettingTranslate(
      id: $id
      input: $input
      languageCode: $language
    ) {
      errors {
        field
        message
      }
      productActivationSetting {
        ...ProductActivationSettingTranslationFragment
      }
    }
  }
`;
export const TypedUpdateProductActivationSettingTranslations = TypedMutation<
  UpdateProductActivationSettingTranslations,
  UpdateProductActivationSettingTranslationsVariables
>(updateProductActivationSettingTranslations);

const updateProductLensTypeTranslations = gql`
  ${productLensTypeTranslationFragment}
  mutation UpdateProductLensTypeTranslations(
    $id: ID!
    $input: NameTranslationInput!
    $language: LanguageCodeEnum!
  ) {
    productLensTypeTranslate(input: $input, languageCode: $language, id: $id) {
      errors {
        field
        message
      }
      productLensType {
        ...ProductLensTypeTranslationFragment
      }
    }
  }
`;

export const TypedUpdateProductLensTypeTranslations = TypedMutation<
  UpdateProductLensTypeTranslations,
  UpdateProductLensTypeTranslationsVariables
>(updateProductLensTypeTranslations);
